import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { isLikelyShipmentId } from '../../utils/publicTrackRoute.js';
import PublicShipmentTracking from './PublicShipmentTracking.js';
import { useTranslation } from 'react-i18next';


/**
 * Catch public links like /SO1-ATHN-26-27 (must be last among app routes).
 */
const PublicTrackByIdRoute = () => {
  const { shipmentId } = useParams();
  if (!isLikelyShipmentId(shipmentId)) {
    return <Navigate to="/" replace />;
  }
  return <PublicShipmentTracking />;
};

export default PublicTrackByIdRoute;
